import { createSelector } from 'reselect'
import { selectCurrentAgentsById } from 'ducks/agents/selectors'
import { selectCurrentTicketAssigneeId } from './selectCurrentTicketAssigneeId'

export const selectCurrentTicketAssignedAgent = createSelector(
  selectCurrentTicketAssigneeId,
  selectCurrentAgentsById,
  (assigneeId, agentsById) => agentsById[assigneeId]
)
